import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bcbf68b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slider-wrapper" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "min-max-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _mergeProps({ class: "slider-input" }, _ctx.$attrs, {
      type: "range",
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', Number($event.target.value))))
    }), null, 16, _hoisted_2),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_ctx.minLabel), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.maxLabel), 1)
    ], 512), [
      [_vShow, _ctx.showLabels]
    ])
  ]))
}